import React from 'react';
import Image, { useFallbackImageSrc } from '../Image/Image';

export default function CarMakeImage({ carMake, gesellschafterNr, height = 40 }) {
    const primarySrc = `https://techno-images.s3.eu-central-1.amazonaws.com/images/brand-icons/${gesellschafterNr}/${carMake}.jpeg`;
    const fallbackSrc = `https://techno-images.s3.eu-central-1.amazonaws.com/images/brand-icons/${carMake}.jpeg`;
    const [src, onError] = useFallbackImageSrc({ src: primarySrc, fallbackSrc });

    return (
        <Image
            src={src}
            alt={carMake}
            resizeHeight={height}
            onError={onError}
        />
    );
}
